module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("O"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("KAY")])])])]), _vm._v(". Okay, so the transformation wasn’t going to be easy, but then, she hadn’t expected it to be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Cinderella had done it with the help of a fairy godmother.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda looked at the cake costume and shuddered. All she had to rely upon were spangles, sequins and Lycra.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Solemnly, she took off her chef’s hat and laid it aside. She unbuttoned her spotless white jacket, took it off, rebuttoned it, folded it carefully and put it next to the hat. Her trousers went next. Zipped, folded neatly on the crease, she added them to the sad little collection.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then she took a deep breath, stepped into the bikini bottom and yanked it up over her hips.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("It didn’t fit. The thong didn’t fit! Hope rushed through her veins. She couldn’t be expected to jump out of a cake in her chef’s outfit. If the costume didn’t fit…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Oh, hell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda moaned softly as she looked at herself in the mirror.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Of course the thong didn’t fit. How could it, when she’d tried pulling it on over her white cotton underpants?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She almost laughed. What a sight she was! Wire-rimmed glasses. No makeup. Hair pulled severely back from her face. A utilitarian, white cotton bra, the white cotton panties…And, over the panties, the thong.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She looked like a cross between Mary Poppins and Madonna.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The desire to laugh slipped away. Lucinda gritted her teeth, shucked off both the thong and the panties, then put the thong on again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Goodbye, Mary Poppins.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("The view wasn’t so bad from the front. Well, it wasn’t good. Still, it covered what had to be covered. But from the back…")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Her face went from pink to red as she twisted and turned and peered at herself in the mirror. The thong went up. It went straight up. It just went up there and disappeared.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Ms. Barry!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("The door jumped under the pounding of Chef Florenze’s fist. Lucinda jumped, too.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Ms. Barry, do you hear me?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("How could she not hear him, she thought bitterly. He was shouting. He had to, she supposed, to make himself heard over the rock and roll music blaring from the ballroom.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Okay, she couldn’t expect a bunch of men at a bachelor party to be listening to Mozart but for heaven’s sake, did they have to listen to some idiot singing that he’d been born to be wild?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Whatever had happened to Chopin?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“You have five minutes, Ms. Barry!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Five minutes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Lucinda swung towards the mirror and stared at herself again. The cotton bra did nothing for the thong. Or maybe it was the thong that did nothing for the bra, she thought, and bit down on her lip.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“This is not funny,” she told herself severely.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("And it wasn’t. The desire to laugh had nothing to do with seeing anything even slightly humorous in the situation. She was verging on hysteria. She remembered the first time it had happened, that out-of-place, overwhelming bark of laughter. It had been the day after her father’s funeral when his attorney had gently told the truth to her mother, and to her…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Lucinda lifted her chin.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("“Just do it,” she said grimly, and she stripped off the cotton bra, put on the spangled demitasse cups, and faced herself in the mirror again.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("It was her reflection that seemed to want to laugh this time. Who are you kidding? it seemed to say.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Never mind the silly excuse for a bra and the thong. She looked about as sexy as a scarecrow.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Any self-respecting male would take one look and beg her to jump back "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("into")])]), _vm._v(" the cake.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda frowned. Well, so what? Even if—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("if")])]), _vm._v("—she did this, whether she looked sexy doing it or not wasn’t her problem. Popping out of the cake was her problem, but as she’d learned over the past two years, desperation could make you do a lot of things. Like waitressing, and flipping hamburgers. Like admitting that being descended from Cotton Mather didn’t mean scratch compared to being descended from a father who’d left behind a house that was mortgaged to the hilt, a defeated wife and a disappointed mistress.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The mistress had found a new man. The wife—Lucinda’s mother—had found a new husband.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And Lucinda was finding a new life.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("At least, that was the plan. It was why she’d put three thousand miles between herself and Boston, come to a city where nobody’s eyebrows would lift when they heard the name “Barry,” and nobody would say, with a little smirk, “Why, Lucinda, however are you, dear?” when what they really meant was, “Oh, Lucinda, how nice to see that the mighty have fallen.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda’s shoulders straightened. It had been a silly life, anyway. The theater. The opera. Charity balls, and endless parties for the needy cause of the moment. Well, she was her own needy cause now. But she’d be a productive citizen, once she had her cooking school certificate in hand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Once she had that job, tomorrow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And there’d be no job, without that certificate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda leaned forward, palms flat on the marble top of the vanity, and stared unflinchingly into the mirror. Oh, yes, she thought wryly. Looking like this, she’d definitely be a big hit at that stag party.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("One by one, she took the pins from her chignon and shook out her hair. Unbound, the straight-as-sticks ash-blond tresses fell heavily to her shoulders.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("That was better, she thought dispassionately.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Now for the glasses. She usually wore contacts but she’d dropped one getting ready to leave the apartment this evening, and there hadn’t been enough time to crawl around on her hands and knees and search for it. She wouldn’t be able to see ")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("that well without the glasses but then, she was going to be the cake decoration, not the decorator.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("Lucinda swallowed hard as she set them on the sink. Her reflection was wavy around the edges. Actually, wavy around the edges was an excellent description of how she felt. Her belly had knotted into one gigantic ball that had lodged itself somewhere between her throat and her all-too-visible navel.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("Was she really going to be the first Barry female ever to emerge, naked, from the center of a giant cake?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("A six-layer white cake, swirled with milk-chocolate frosting and decorated with marzipan hearts and stars. She’d applied them herself, just this afternoon…")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("Lucinda gave herself a little shake. What did it matter who’d applied what to the damned thing? Besides, Chef Florenze had made it clear she would not actually leap through the real cake. Why ruin the best part of a dozen eggs, two pounds of butter, and all that confectioner’s sugar?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“It will be a cardboard cake,” he’d said while she’d gawked at him. “You will pop from it cleanly.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("Perhaps it was his incredible assumption that she’d even consider doing such a thing. Perhaps it was his solemn assurance that she wouldn’t have to contend with leaping through the butter-cream frosting. Whichever, a wild image had bloomed in Lucinda’s head. She’d pictured herself bursting from the top of a cardboard cake wearing the tiara, the thong, the barely-there excuse for a bra, and a jack-in-the-box mask.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("The first semi-crazed snort of amusement had burst from her throat. The chef, naturally enough, had misunderstood.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Ah,” he’d said with a beaming smile, “I am delighted to see that this little assignment is to your liking, Ms. Barry. I had, if only for a moment, feared you might, ah, might not be pleased with it.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Pleased?” Lucinda had repeated, the urge to laugh buried under the stronger urge to connect her fist with Chef Florenze’s chubby triple chins. “"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Pleased")])]), _vm._v(" with being told you want me to display myself, naked, to a mob of howling hyenas?” She’d looked down at the small white box that held the costume he ")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("wanted her to wear and shoved it back at him. “Have you lost your mind?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Ms. Barry. I have explained the situation. The actress hired for the occasion—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Actress,” Lucinda said, and gave another snort, though not of amusement.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“She has fallen ill. And you must take her place. I’ve told you that three times.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“And I’ve told you that I’m here to cook, not to—to entertain a bunch of degenerates.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("The chef drew himself up. “Degenerates, indeed,” he said coldly. “These men are drawn from the finest families in San Francisco. They are captains of industry.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“They are drunk,” Lucinda replied, even more coldly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“They’re celebrating. And a girl popping out of a cake is part of the celebration.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Call a modeling agency. Call wherever it is you hired that ‘actress’ and hire another.” Lucinda folded her arms and looked the chef in the eye. “I’m not doing it.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Florenze waved a pudgy hand at the wall clock. “It’s almost ten at night. The agency is closed.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“A pity.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“Do you recall culinary lesson three? How to improvise when the soufflé falls?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“What has that to do with this?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“I am improvising, Ms. Barry. I am making do with the materials at hand.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Lucinda’s eyes narrowed. “I am neither an egg white nor a bar of bitter chocolate, Chef Florenze.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("The chef smiled thinly. “Look around you. Go on, look. What do you see?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“The kitchen in which I’m supposed to be working.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“What you see,” he said impatiently, “are six students. Three men, three women, yourself included.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“So?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“So,” the chef purred, “I suspect we can agree that our guests would be less than delighted if Mr. Purvis, Mr. Rand or Mr. Jensen leaped from a cake tonight, hmm?”")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda said nothing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can we agree, too, that the venerable Miss Robinson would surely get hurt trying to extricate herself from anything other than an armchair? And that Mrs. Selwyn would never fit inside a cake unless it had the dimensions of Cheops’ pyramid?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What you’re asking me to do is a barbaric, sexist, disgusting custom.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So are half the things done on this planet, but we are not anthropologists, we are caterers.” The chef moved closer. “Our catering contract calls for roast beef, barbecued pork, filet of sole almondine, assorted salads and breads, coffee, beverages—and a giant cardboard cake that contains a young lady. Is that clear?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A very strange contract for a catering firm, if you ask me.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not asking you for legal advice, Ms. Barry. I am telling you that you will put on that costume and do what must be done.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I paid my tuition to be taught to cook.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The chef had smiled slyly at that, and Lucinda had, for the first time, felt the ground slip, ever so slightly, beneath her feet.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Which you have not learned to do very well.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was right, but what did that have to do with anything? “I attended the specified number of classes,” she’d said coolly. “I passed all the exams. I earned my certificate.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The chef, damn him, had laughed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All your exams but the last,” he’d said. “And you won’t get your certificate, if you fail tonight’s test.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Meaning, Lucinda thought as she looked into the mirror, meaning, she would have to pop out of that miserable cardboard creation or walk away from Chef Florenze’s culinary school without the piece of paper she so desperately needed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With it, she’d be a woman with a skill. She could parlay the cook’s job the school had lined up for her into a job as a sous-chef at a restaurant, and go from that into being a full-fledged chef with her own restaurant someday, or her own catering firm…")])])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Without it, she’d be back to waitressing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s blackmail,” Lucinda had protested, and Chef Florenze had shown his teeth beneath his skinny excuse of a mustache and said yes, yes, it was, and she was welcome to try and prove any of this conversation had taken place because it hadn’t.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just think of this as your fifteen minutes of fame,” he’d purred. “Your once-in-a-lifetime moment in the sun—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Just give me the miserable costume and shut up,” Lucinda had snapped, and startled the both of them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And now, here she stood. In the wings, as it were, dressed in little more than a handkerchief and two halves of a diaphanous, spangled eggshell.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lucinda,” she said aloud, “are you insane?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had to be, even to have contemplated doing this thing.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Ridiculous,” she said, and quickly gathered her hair at the base of her neck.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The audacity of Chef Florenze. The nerve! How dare he do this to her? She was a Barry, and Barrys had stood firm on their principles for more than three hundred years. Well, except for her father, of course. But other Barrys had always Done The Right Thing. Hepzibah Barry had been burned alive in Salem, rather than say she was a witch. Could she, Lucinda Barry, do any less in the face of misfortune?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lucinda?” The doorknob rattled. “Lucinda, open this door at once!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The voice was faint but unmistakable. Miss Robinson was demanding entry.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Oh, Lord. Miss Robinson. Eighty years old, at least. Tiny, ramrod-straight Miss Robinson, with her permed silver hair, her black dresses buttoned to the throat and wrist, her parchment-paper skin…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Lucinda! Open the door and let me in.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda undid the lock and cracked the door an inch. “Miss Robinson.” She took a breath. “I’m, uh, I’m kind of busy in here. If you need to use the, uh, if you need to use the facilities, I’m afraid you’ll have to—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’ve come to talk to you. Stop babbling and let me inside.”")])])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda grabbed a guest towel from the vanity, clutched it to her bosom and opened the door just wide enough to let the old woman enter.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Now,” Miss Robinson said briskly, “why are you hiding in here? What is this nonsense about?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda’s brows arched. “Miss Robinson,” she said politely, “I appreciate your concern, but this, ah, this situation has nothing to do with—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why are you stumbling all over your words? And why are you holding on to that towel as if it were the last life jacket on the "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Titanic?")])]), _vm._v("”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well—well, because what I’m wearing is—is—” Lucinda frowned, took a deep breath and dropped the towel to the tile floor. “This is why,” she said coolly. “As you can see, I’m not exactly dressed for company.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The expression on the old woman’s face didn’t change as she looked Lucinda up, then down, then up again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Skimpy,” she said at last.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda managed a tight smile. “Indeed.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But I’ve seen bathing suits as revealing on the beach.” Miss Robinson shook her head. “The things young women wear nowadays…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, well, not "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("this")])]), _vm._v(" young woman!” Lucinda swung back towards the mirror and plucked a bobby pin from the counter. “Would you believe that Chef Florenze actually expects me to wear this thing? To scrunch down under a serving cart and…” Her eyes met the older woman’s in the mirror. “Never mind. It doesn’t bear repeating. Suffice it to say, I’m not going to do it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t be ridiculous,” Miss Robinson said irritably. She reached out and snatched the pins from Lucinda’s hair as fast as Lucinda anchored them. “Of course, you’ll do it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Miss Robinson,” Lucinda said patiently, “you have no idea what the chef wants.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He wants you to jump out of a cardboard cake so those silly boys in the ballroom can clap their hands, whistle like banshees and generally make asses of themselves.”")])])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda stared at the other woman in the mirror. Then she turned and stared at her some more.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He told you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He told everyone. He also told us you’ve locked yourself in here and refuse to emerge.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Did he mention that he’s threatened to blackmail me? That he won’t give me my certificate if I don’t cooperate?” Lucinda smiled tightly. “Well, that nasty little man is in for a surprise. He doesn’t believe I’ll bring charges against him, but I will. I’ll take him to court. I’ll sue. I’ll go to the papers…What?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That ’nasty little man’ has expanded the scope of his ultimatum. Either you do as he’s ordered, or none of us will get our certificates.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But—but he can’t do that.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Mrs. Robinson stamped her foot. “Don’t be so naive, Lucinda! Of course he can do it. He can do whatever he likes. And you can do whatever you like about fighting him, but by the time the problem’s resolved, it will be too late.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s not so,” Lucinda said stubbornly. “The chef will still have to hand over those certificates, whether it’s tonight or next week or next month.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, but that will be too late for Mr. Purvis, who’s already accepted a restaurant position, and for the Rand lad. Did you know he took a student loan to pay for this course?” Miss Robinson put her bony hands on her hips. “And definitely too late for me. A woman my age has little time to spare.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t be silly. Why, you don’t look a day over—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t patronize me, girl.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not, I just…” Lucinda huffed out a breath. “Miss Robinson, now you’re the one who’s trying blackmail!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s reality, not blackmail. Is your pride so important you’d ruin things for the rest of us?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Pride has nothing to do with this. It’s a matter of principle.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The old lady snorted. “Better to concern yourself with the sort of principal that pays bills.” Her eyes fixed on Lucinda’s face. “How much has that horrid little man offered to pay you?”")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Pay me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“For this cake-jumping business.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why—why, nothing. He said he wouldn’t give me my certificate unless—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell him you’ll do it for two hundred dollars.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda stared at the old woman. “There’s not a way in the world I’d do this, not even for—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Three hundred, then.” Miss Robinson lifted a brow. “Unless, of course, you don’t need money any more than you need that job you told us about, the one you’re "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("supposed")])]), _vm._v(" to start tomorrow morning.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda glared at Miss Robinson. Old people were supposed to be sweet-natured and kindhearted but this one looked as if she had the disposition of an alligator.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Of course I need money,” she said coldly. “And the job, too.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Then let down your hair, put on some lipstick, and get this over with.” A sudden, wicked glint lit the old lady’s eyes. “At least, you’ll have a bra to wear. I didn’t, back in the days when I was a showgirl with the Folies Bergère.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda’s jaw dropped. “When you…”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Indeed. When the heating system went on the blink at the Folies, the entire audience could tell you were cold.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Miss Robinson winked and turned around. The door swung shut after her. Lucinda hesitated. Then she turned and met her own gaze in the mirror.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The Folies Bergére? She tried to imagine Miss Robinson strutting down a runway dressed in feathers and a smile. Dressed in lots less than this costume, that was for sure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Okay. So, maybe she had seen swimsuits as revealing on the beach. She’d never worn one, of course; she’d never worn anything more showy than the black tank suit she’d worn when she was a student at the Stafford School.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Only a madwoman would go from that stretched-out nylon tank to this bit of spangles and Lycra.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She turned, poked one shoulder towards the mirror.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('span', [_vm._v("Besides, even if she were to agree to do this thing—not that ")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("she would, but it didn’t hurt to pretend—if she did, the men attending the bachelor party would be sorely disappointed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("Lucinda backed up a little, put on her glasses and took a better look.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("Her neck was long, her shoulders too bony, her breasts too small.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("She turned a little more, narrowed her eyes and took another look.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("Well, small, yes. But rounded, and high. She sucked in her breath. Definitely, rounded and high. Her tummy was flat, her waist narrow. That was good. Her hips weren’t much but her backside seemed okay. From what she’d heard, men liked women to have okay backsides. Long legs, too. And hers were surely that. She’d always had trouble buying panty hose that was long enough without being saggy and baggy on top…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("What was she thinking? She’d never go out there. Never.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Do you want that job, Lucinda?")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("Oh, Lord. Yes. Yes, she did. She’d interviewed for it with a sweet old woman. A Mrs. Romano, who’d seemed undeterred by her inexperience.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Never mind,” Mrs. Romano had said reassuringly. “My grandson won’t be picky, Luciana.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“It’s Lucinda,” Lucinda had said politely. “He won’t be?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“No. You see, he needs you.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Needs me? I don’t understand.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“He is a busy man. Always going here and there. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Molto importante,")])]), _vm._v(" yes? But he lacks something in his life.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“A cook?” Lucinda had said helpfully.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Exactly. He doesn’t eat right. He doesn’t touch his vegetables.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Vegetables.” That was good. She could prepare green salads with the best of them.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“You will love working for him, Luciana.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Lucinda.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('span', [_vm._v("“Of course. Lucinda. He’s very easygoing. Charming, and gentle.” Mrs. Romano had clasped her hands and sighed. “He is caring. And sensitive. My Joseph is the most sensitive man in all of San Francisco.”")])])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gay, was what she’d meant. Lucinda had understood the code word, and the job had become even more appealing. A wealthy gay man who traveled a lot would be easy to work for. Gay men abounded in San Francisco, and the ones Lucinda had met were invariably low-key, gentle, and kind.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Kind enough to hire her, if the chef flunked her out of the cooking school?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No way,” Lucinda said, and knew the time for excuses was long gone.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She kept Miss Robinson firmly in mind as she let down her hair and ran her hands through it until it had the tousled look she’d noticed in magazine ads. She had no lipstick; she rarely used makeup. But there was a little cosmetics bag in the costume box. Inside, she found eye shadow. Eyeliner. Lucinda used them all, then bit her lips to pinken them. Finally, she put on the tiara and squinted at herself in the mirror.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Something was missing, but what? Her hair was okay. The glasses were gone. The costume fit as well as it was going to fit. Still, there was more. She’d forgotten something…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She jumped as a fist pounded against the closed door. “Well, Ms. Barry?” Chef Florenze boomed. “Are you going to grace us with your presence?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda put her hand to her heart, as if to keep it from bounding out of her chest. Then, before she could change her mind, she unlocked the door and marched out.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Very sensible of you, Miss Barry,” the chef said with an unctuous smile.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lucinda marched up to him. “Three hundred bucks, or I don’t move from this spot.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t be ridiculous.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Three hundred.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Florenze’s narrow mustache twitched. “Two.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Two-fifty.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Listen here, young woman—” Something in her eyes must have convinced him that she meant it. “Two-fifty,” he said, “and snap to it.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('span', [_vm._v("“That’s the spirit,” she heard Miss Robinson say as she ")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("strode to the serving cart that held the cardboard cake and climbed under it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("Her stomach gave a dangerous lurch. So did the cart. The rubber wheels squealed as she, and it, were pushed across the floor. Doors slammed against walls as they were opened. She heard the sounds of music and male laughter, and then the pounding of a chord—C major, she thought dispassionately—on a piano.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Gentlemen,” a deep voice cried, “to Arnie and his loss of freedom!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“To Arnie,” other male voices chorused.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Now, Ms. Barry,” Chef Florenze hissed, and Lucinda took a breath and burst through the top of the cake, arms extended gracefully above her head, just as if she were back in Boston, diving not up into the noise and the light but down, down, down into the glassy depths of a warm, blue pool.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("But it wasn’t a pool, it was a stage, and she hadn’t burst free of the cardboard cake. She’d gotten tangled in it. And while she was still blinking and fighting furiously to extricate herself from the horrible chunks of cardboard, two things happened, almost simultaneously.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("The first was that she realized that the “something” she’d forgotten were her low-heeled, sensible white shoes. They were still on her feet.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("The other was that a man, a blur of muscles and blue eyes and black hair, had come to her rescue.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Just put your arms around my neck, honey, and hang on.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“I am not your honey,” Lucinda said. “And I don’t need your help!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("She slapped at his hands as he reached for her but his arms closed around her, anyway. The crowd cheered as he hoisted her into his arms.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Go for it, Joe,” somebody yelled, and the man grinned, right into her eyes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('span', [_vm._v("“Love those shoes,” he purred, and when the crowd cheered again, he bent his head, covered her mouth with his, and kissed her.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4bde30a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/romanosrevenge_ch02.vue
// module id = 75
// module chunks = 0